import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FontAwesome__triangle-bottom-right",
  "use": "FontAwesome__triangle-bottom-right-usage",
  "viewBox": "0 0 9 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 9 10\" id=\"FontAwesome__triangle-bottom-right\"><path fill=\"#545455\" d=\"m8.828 8.748-8.673.675L8.391.06l.437 8.688Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol